export const abc = 'test';
export const DATE_FORMAT = 'MM-DD-YYYY';
export const DATE_TIME_FORMAT = 'MM-DD-YYYY h:m A';
export const MASTER_DROPDOWN_PAGE_SIZE = 30;
export const PAGE_SIZE = 10;